<template>
    <div>
        <p class="text-bold">{{ _.get(asset, 'name') }}</p>
        <p class="small-link">{{ path.replace(/\//g, '/') }}</p>
    </div>
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';

export default {
    data() {
        return {

        }
    },

    components: {

    },

    props: ['css', 'data', 'config'],

    computed: {
		...Vuex.mapGetters('assets', {
			assets: 'content',
		}),

        asset() {
			return _.get(this.data, this.config.assetField, {});
        },

        path() {
            let path = [];
            let currentNode = this.asset;
            while(currentNode) {
                path.push(currentNode.name);
                currentNode = _.chain(this.assets)
                    .get('data', []).find(asset => asset.id == currentNode.parent_id).value();
            }
            path.push(this.asset.storage);
            return path.reverse().join('/');
        },
    },

    mounted() {

    },

    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/AssetInfoComponent.vue